<div class="container">
    <div class="card">
        <div class="card-body">
            <div class="panel panel-primary">
                <div class="panel-heading custom-panel">
                    <div class="titulo-painel-left">
                        <h2>Reenvio Comprovante - Marcação de Consultas</h2>
                    </div>
                </div>
            </div>

            <div>
                <form [formGroup]="formularioDeReenvioComprovanteSelecionarMarcacao" (ngSubmit)="onSubmit()"
                    (keydown.enter)="$event.preventDefault()">
                    <div class="form-group">
                        <mat-divider fxFlex="1 0"></mat-divider>
                    </div>

                    <div class="form-row">
                        <mat-form-field class="form-group col-lg-8 col-md-8 col-sm-12 col-12">
                            <mat-label>Paciente</mat-label>
                            <input matInput value="Paciente" class="form-control" id="nome" required name="nome"
                                upperCase formControlName="nome">
                        </mat-form-field>

                        <mat-form-field class="form-group col-lg-4 col-md-4 col-sm-12 col-12">
                            <mat-label>Núm. Celular</mat-label>
                            <input matInput value="Núm. Celular" class="form-control" id="foneCelular"
                                name="foneCelular" phoneMask [maskInputId]="'foneCelular'"
                                [preValue]="formularioDeReenvioComprovanteSelecionarMarcacao.value.foneCelular"
                                [phoneControl]="formularioDeReenvioComprovanteSelecionarMarcacao.controls['foneCelular']"
                                formControlName="foneCelular" minlength="14" maxlength="16" required>
                            <mat-error
                                *ngIf="!formularioDeReenvioComprovanteSelecionarMarcacao.controls.foneCelular.hasError('required') && formularioDeReenvioComprovanteSelecionarMarcacao.controls.foneCelular.errors">
                                O campo Núm. Celular está inválido.
                            </mat-error>
                            <mat-error
                                *ngIf="formularioDeReenvioComprovanteSelecionarMarcacao.controls.foneCelular.hasError('required')">
                                O campo Núm. Celular é obrigatório.
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="card">
                        <div class="card-header">Marcações</div>
                        <div class="card-body" style="padding-bottom: 0px;">
                            <table class="table table-striped table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col"></th>
                                        <th scope="col">Data Atd.</th>
                                        <th scope="col">Plano Saúde</th>
                                        <th scope="col">Consulta</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let marcacao of listaMarcacoes; let i = index">
                                        <td>
                                            <input type="radio" [checked]="marcacao.selected"
                                                name="{{marcacao.pkConsultaDaEntidadeConcatenada}}"
                                                (click)="selecionarMarcacao(marcacao)">
                                        </td>
                                        <td>{{marcacao.dataMarcacao | date:"dd/MM/yyyy"}}</td>
                                        <td>{{marcacao.nomePlanoSaude}}</td>
                                        <td>{{marcacao.nomeProcedimentoConsulta}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="menu-formulario">
                        <div class="menu-formulario-botoes margin-right-10">
                            <button mat-mini-fab color="success" type="submit" matTooltip="Reenviar Comprovante"
                                [disabled]="!formularioDeReenvioComprovanteSelecionarMarcacao.valid">
                                <mat-icon>send</mat-icon>
                            </button>
                        </div>
                        <div class="menu-formulario-botoes">
                            <button type="button" mat-mini-fab color="primary" (click)="gotoList()" matTooltip="Voltar">
                                <mat-icon>west</mat-icon>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>